<template>
  <el-dialog
    :visible.sync="statementModalShow"
    :title="
      statementTypeGroup
        ? 'Group Statement Generation'
        : 'Individual Statement Generation'
    "
    @closed="$emit('close')"
    width=" 55%"
  >
    <div class="w-100 d-flex flex-column mb-3">
      <label for="statement-date">Statement Date</label>
      <form autocomplete="off">
        <el-date-picker
          id="statement-date"
          ref="statementDate"
          v-model="statementDate"
          type="date"
          autocomplete="off"
          value-format="yyyy-MM-dd"
          placeholder="Pick a day"
        >
        </el-date-picker>
      </form>
    </div>
    <div v-if="statementTypeGroup" class="w-100 d-flex justify-content-between">
      <div class="d-flex flex-column">
        <label>Scope</label>
        <el-radio-group v-model="statementScope">
          <el-radio-button label="All Trades" />
          <el-radio-button label="Open Trades" />
        </el-radio-group>
      </div>
      <div class="d-flex flex-column">
        <label>Format</label>
        <el-radio-group v-model="statementFormat">
          <el-radio-button label="Web Only" />
          <el-radio-button label="PDF" />
        </el-radio-group>
      </div>
      <div class="d-flex flex-column">
        <label>Type</label>
        <el-radio-group v-model="statementType">
          <el-radio-button label="Summary" />
          <el-radio-button label="Detail Statement Summary" />
        </el-radio-group>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="statementModalShow = false">Cancel</el-button>
      <el-button
        type="primary"
        @click="generateStatement"
        :loading="generateStatementLoading"
        >Generate</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    initial_business_id: {
      type: Number,
    },
    statementTypeGroup: {
      type: Boolean,
    },
    purchase_id: {
      type: Number,
    },
  },
  data() {
    return {
      statementModalShow: true,
      statementDate: "",
      statementScope: "Open Trades",
      statementType: "Detail Statement Summary",
      statementFormat: "Web Only",
      generateStatementLoading: false,
    };
  },
  methods: {
    generateStatement: function (id = null) {
      if (this.purchase_id) this.generateIndividualStatement();
      else this.generateGroupStatement();
    },
    generateIndividualStatement: async function (id) {
      this.generateStatementLoading = true;
      await axios
        .post(
          `/api/v2/portal/businesses/${this.initial_business_id}/statements`,
          {
            date: this.statementDate,
            format: "pdf",
            purchase_id: this.purchase_id,
          },
        )
        .then((res) => {
          this.$message({
            type: "info",
            message:
              "Creating statement, this may take a couple of minutes to generate.",
          });
          this.$emit("close");
        })
        .catch((err) => {
          let errorText = "";
          _.forEach(err.response.data.errors, function (value) {
            errorText += "" + value + " ";
          });

          this.$message({ type: "error", message: errorText || err.message });
        })
        .finally((_) => {
          this.generateStatementLoading = false;
        });
    },
    generateGroupStatement: async function () {
      this.generateStatementLoading = true;
      let format = this.statementFormat == "PDF" ? "pdf" : "web_only";
      await axios
        .post(
          `/api/v2/portal/businesses/${this.initial_business_id}/statements`,
          {
            scope: this.statementScope == "All Trades" ? "all" : "open",
            type:
              this.statementType == "Summary" ? "summary" : "summary_detail",
            date: this.statementDate,
            format: format,
          },
        )
        .then((res) => {
          let statement = res.data;
          this.$message({
            type: "info",
            message:
              "Creating statement, this may take a couple of minutes to generate.",
          });
          this.$emit("close");
          /*if (format == "web_only") {
            window.open(statement.url, "_blank");
          } else {
            window.open(`${statement.media[0].download_url}`, "_blank");
          }*/
        })
        .finally((_) => {
          this.generateStatementLoading = false;
          //this.$emit("close");
        });
    },
  },
};
</script>
